export const cardShell = {
  borderRadius: 24,
  padding: '22px 24px',
  background: 'var(--card-solid)',
  border: '1px solid var(--s10)',
  boxShadow: 'inset 0 1px 0 var(--s10), 0 18px 44px var(--sh40)',
};

export const fieldStyle = {
  padding: '13px 16px',
  borderRadius: 14,
  background: 'var(--field)',
  border: '1px solid var(--s10)',
  fontSize: 13.5,
  color: 'var(--tx)',
  fontFamily: 'inherit',
  outline: 'none',
  width: '100%',
};

export const fieldLabel = {
  fontSize: 11.5,
  color: 'var(--mut)',
  marginBottom: 7,
};

export const iconBtn = {
  width: 44,
  height: 44,
  borderRadius: 14,
  display: 'grid',
  placeItems: 'center',
  background: 'linear-gradient(160deg, var(--s09), var(--s02))',
  border: '1px solid var(--s10)',
  color: 'var(--tx2)',
  cursor: 'pointer',
  padding: 0,
};

export const redCta = {
  display: 'flex',
  alignItems: 'center',
  gap: 9,
  padding: '10px 22px',
  borderRadius: 999,
  background: 'linear-gradient(160deg, rgba(125,1,12,0.60), rgba(74,1,7,0.45))',
  border: '1px solid rgba(190,50,62,0.45)',
  boxShadow: 'inset 0 1px 0 var(--s25), 0 10px 26px rgba(125,1,12,0.50)',
  fontSize: 14,
  fontWeight: 600,
  color: 'var(--red-tx)',
  cursor: 'pointer',
};

export const tabRail = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  padding: 6,
  borderRadius: 999,
  background: 'var(--card-solid)',
  border: '1px solid var(--s10)',
};

export const pageTitle = {
  fontSize: 34,
  fontWeight: 600,
  letterSpacing: '0.01em',
};

export const formatEgp = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return '0.00';
  return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatInt = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return '0';
  return v.toLocaleString('en-US');
};

export const statusTone = (status) => {
  const s = String(status || '').toLowerCase();
  if (['confirmed'].some((k) => s.includes(k))) {
    return { color: '#7fd6a2', bg: 'rgba(46,160,94,0.14)', border: 'rgba(46,160,94,0.35)' };
  }
  if (['delivered', 'received', 'successful', 'exchanged', 'active', 'resolved', 'approved', 'completed', 'accepted', 'fulfilled'].some((k) => s.includes(k))) {
    return { color: '#ACBBC6', bg: 'rgba(172,187,198,0.12)', border: 'rgba(172,187,198,0.30)' };
  }
  if (['cancel', 'return', 'fail', 'reject', 'unsuccessful', 'sold out'].some((k) => s.includes(k))) {
    return { color: 'var(--red-tx2)', bg: 'rgba(125,1,12,0.40)', border: 'rgba(190,50,62,0.45)' };
  }
  if (['pending', 'progress', 'attempt', 'transit', 'picked', 'prepared', 'heading', 'unpaid'].some((k) => s.includes(k))) {
    return { color: 'var(--red-tx3)', bg: 'rgba(226,112,124,0.14)', border: 'rgba(226,112,124,0.35)' };
  }
  return { color: 'var(--tx2)', bg: 'var(--s06)', border: 'var(--s12)' };
};

export const StatusPill = ({ status, children }) => {
  const tone = statusTone(status);
  return (
    <span
      style={{
        display: 'inline-flex',
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: 10.5,
        fontWeight: 600,
        color: tone.color,
        background: tone.bg,
        border: `1px solid ${tone.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      {children || status}
    </span>
  );
};
